'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosEmail = function IoIosEmail(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 30h-30v-18.9l10.2 7.8-5.3 6 0.2 0.2 6.2-5.5 3.7 2.9 3.8-2.9 6.1 5.5 0.2-0.2-5.3-6 10.2-7.8v18.9z m-0.6-20l-14.4 10.9-14.4-10.9h28.8z' })
        )
    );
};

exports.default = IoIosEmail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-email.js
// module id = 2147
// module chunks = 0